import { reduce } from 'lodash';
import { PipeResponse } from '../../shared/pipes/pipeResponse';
import { getTreeWithEmptyStats } from '../../shared/quote-or-design-form/map/map-helpers/getTreeWithStats';
import { generateMapFromTree } from '../../shared/quote-or-design-form/map/map-helpers/mapHelpers';
import { Tree } from '../../shared/quote-or-design-form/map/map-helpers/treeHelpers';
import { MapNode, MapNodeType } from '../../shared/quote-or-design-form/map/mapNode';
import { TreeNodeType } from '../../shared/quote-or-design-form/map/treeNode';

export const getDimensions = (
  size: number,
  pipeDiameters: Array<number | null>,
  pumpId: number | null,
  pumpText: 'FullText' | 'Asterisk' = 'FullText',
): string => {
  const height = pipeDiameters.some(diameter => diameter === 10) ? 800 : 600;
  const manifoldWidth = size === 1 ? 315 : 295 + 50 * (size - 1);
  const pumpWidth = pumpId !== null ? 105 : 0;
  const depth = pumpId !== null ? 195 : 95;
  const supplementalText = pumpText === 'FullText' ? ' including pump & blending valve assembly' : '*';

  return `${height}(h) x ${manifoldWidth + pumpWidth}(w) x ${depth}(d)${pumpId !== null ? supplementalText : ''}`;
};

export const getLetterOrdinalAndLocationForManifold = (name?: string) => {
  if (!name) {
    return ['', ''];
  }
  const firstSplit = name.split(LOCATION_SEPARATOR);
  const location = firstSplit.length > 1 ? firstSplit[1] : '';
  const secondSplit = firstSplit[0].split(' ');
  const manifoldName = secondSplit.length > 1 ? secondSplit[1] : '';
  return [manifoldName, location];
};

export const getManifoldDisplayName = (name: string) => {
  return name.split(LOCATION_SEPARATOR)[0];
};

export const getPipelineMapWaterVolume = (pipelineMapJson: string, pipes: Array<PipeResponse>) => {
  if (!pipelineMapJson || pipes.length === 0) {
    return null;
  }

  const tree = JSON.parse(pipelineMapJson) as Tree;
  const map = generateMapFromTree(getTreeWithEmptyStats(tree)).map;

  return reduce(
    map,
    (mapVolume, node: MapNode) => {
      if (node.type === MapNodeType.Pipe && node.data.parentTreeNode) {
        const pipeData =
          node.data.parentTreeNode.nodeType === TreeNodeType.Junction && !node.data.isFirstChild
            ? node.data.parentTreeNode.secondChild.exitPipe
            : node.data.parentTreeNode.firstChild.exitPipe;

        const pipeType = pipes.find(pipe => pipe.code === pipeData.code);
        if (!pipeType || !pipeData.lengthInMetres) {
          return mapVolume;
        }
        // we double the length to account for the return pipe
        return mapVolume + pipeData.lengthInMetres * 2 * pipeType.waterContentInLitresPerMetre;
      }
      return mapVolume;
    },
    0,
  );
};

const LOCATION_SEPARATOR = ' - ';
